<div class="modal-content">
    <div class="modal-header">
        <h2>{{ modal?.title }}</h2>
        <lsq-button
            *ngIf="!isSubmitting"
            appearance="transparent"
            class="close"
            ariaLabel="Close"
            (buttonClick)="modalService.closeModal()"
        >
            <lsq-icon aria-hidden="true" [type]="icons.Close" [color]="color.Black"> </lsq-icon>
        </lsq-button>
    </div>
    <div class="modal-body" *ngIf="isSubmitting">
        <lsq-circle-loader></lsq-circle-loader>
    </div>
    <div class="modal-body" *ngIf="!isSubmitting">
        <form [formGroup]="formGroup">
            <lsq-input
                [(ngModel)]="modal?.data.label"
                [disabled]="true"
                formControlName="documentName"
                name="documentName"
                label="Document Name"
                [group]="formGroup"
            >
            </lsq-input>
            <lsq-input
                formControlName="documentNotes"
                name="documentNotes"
                label="Document Notes"
                [group]="formGroup"
            >
            </lsq-input>
            <div class="file-section">
                <lsq-input
                    [placeholder]="
                        !!this.formGroupFile ? this.formGroupFile.name : 'Attach Document*'
                    "
                    [disabled]="true"
                >
                </lsq-input>
                <lsq-button
                    type="button"
                    appearance="secondary"
                    (buttonClick)="documentFile.click()"
                >
                    Browse
                    <input
                        #documentFile
                        formControlName="documentFile"
                        name="documentFile"
                        type="file"
                        [accept]="modal?.data?.fieldOption?.fileExtensions"
                        (change)="onFileChange($event)"
                        id="documentFile"
                        class="file-input-field"
                    />
                </lsq-button>
            </div>
            <div class="asOfDate" style="margin-top: 1em;">
                <span>As of Date</span>
                <lsq-input
                    type="date"
                    name="asOfDate"
                    [formControlName]="'asOfDate'"
                    [name]="'asOfDate'"
                    [group]="formGroup"
                >
                </lsq-input>
            </div>

            <!-- <lsq-checkbox
                label="Date Range"
                [id]="'date-range'"
                [formControlName]="'isDateRange'"
                [group]="formGroup"
                (change)="toggle()"
            >
            </lsq-checkbox>
            <div class="endDate" *ngIf="show" style="margin-top: 1em;">
                <span>End Date</span>
                <lsq-input
                    type="date"
                    name="endDate"
                    [formControlName]="'endDate'"
                    [name]="'endDate'"
                    [group]="formGroup"
                >
                </lsq-input>
            </div> -->

            <div class="modal-footer" *ngIf="!isSubmitting">
                <div class="modal-footer-left">
                    <lsq-button
                        appearance="secondary"
                        (buttonClick)="modalService.closeModal()"
                        class="cancel-btn pull-left"
                    >
                        Cancel
                    </lsq-button>
                </div>
                <div class="modal-footer-right">
                    <lsq-button
                        appearance="primary"
                        class="confirm-btn"
                        [size]="'lg'"
                        (buttonClick)="confirmModal()"
                        [disabled]="!this.formGroup.valid"
                    >
                        Upload Document
                    </lsq-button>
                </div>
            </div>
        </form>
    </div>
</div>
